import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export const SocialProofToast = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Auto hide after 6 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    }, 5000); // Show after 5 seconds
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-154">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 z-50 max-w-sm p-4 bg-brand-card border border-brand-gold/30 rounded-xl shadow-2xl flex items-start gap-3" data-id="element-155">
          <div className="bg-green-500/20 p-1 rounded-full mt-0.5" data-id="element-156">
            <CheckCircle className="w-5 h-5 text-green-400" data-id="element-157" />
          </div>
          <div data-id="element-158">
            <p className="text-sm text-white font-medium" data-id="element-159">
              <span className="font-bold" data-id="element-160">Alejandro de Tucumán</span> acaba de
              comprar Marketing PRO
            </p>
            <p className="text-xs text-brand-gold mt-1" data-id="element-161">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};